/*eslint-disable */
import React, { useState } from 'react'

import styles from './styles'
import Info from 'public/assets/svg/info.svg'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import { motion } from 'framer-motion'
import ShareMenuContainer from '../../containers/ShareMenu'
import { sanitize } from 'dompurify'

const Photoviewer = props => {
    const [description, setDescription] = useState(false)

    const { media, selectedIdx, inst_id, loc_id, classes } = props

    const { photoid } = media[selectedIdx]
    const descriptionInfo = media[selectedIdx].description
    const shareUrl = `${process.env.REACT_APP_BASE_URL}/tour/photos/${inst_id}/${loc_id}?id=${photoid}`

    const animations = {
        open: {
            x: '0%',
            transition: {
                ease: [0.28, 0.57, 0.2, 1],
                duration: 0.5,
            },
        },
        closed: {
            x: '100%',
            transition: {
                ease: 'easeIn',
                duration: 0.25,
            },
        },
    }

    return (
        <div className={classes.viewer}>
            <div className={classes.imgText} data-testid="title">
                {media[selectedIdx].title}
            </div>

            <picture>
                <source srcSet={media?.[selectedIdx]?.urls?.large} media="(min-width: 1024px)" />
                <source srcSet={media?.[selectedIdx]?.urls?.medium} media="(min-width: 768px)" />
                <img
                    src={media?.[selectedIdx]?.urls?.medium}
                    className={classes.img}
                    data-testid="photo"
                    alt="Responsive image"
                />
            </picture>

            <motion.div
                initial={{ x: '100%' }}
                variants={animations}
                animate={description ? 'open' : 'closed'}
                className={classes.infoPanel}
            >
                <div
                    className={classes.description}
                    data-testid="description"
                    dangerouslySetInnerHTML={{
                        __html: sanitize(descriptionInfo, { ADD_ATTR: ['target'] }),
                    }}
                ></div>
            </motion.div>

            {descriptionInfo && (
                <div className={classes.info} onClick={() => setDescription(!description)} data-testid="info">
                    <img src={Info} />
                </div>
            )}

            <div className={classes.shareMenu}>
                <span
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        bottom: '0%',
                        right: '0%',
                    }}
                >
                    <ShareMenuContainer url={shareUrl} className={classes.shareMenu} svgColor="#FFFFFF" />
                </span>
            </div>
        </div>
    )
}

export default compose(injectSheet(styles))(Photoviewer)
